.cuttingTool-dropDown,
.cuttingTool-unitField {
  border: 1px solid #bbb;
  box-sizing: border-box;
  color: #595959;
  font-family: inherit;
  font-size: 1rem;
  height: 2rem;
  line-height: 2rem;
  padding: 3px 5px;
  margin-right: 0;
}

.cuttingTool-dropDown {
  min-width: calc(100% - 15px);
}

.cuttingTool-tableHeader {
  text-align: left;
}

.cuttingTool-groupName {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.cuttingTool-inputField {
  width: 1px;
}

.leftPadding {
  width: 50px;
  max-width: 50px;
  min-width: 50px;
}

.spacer {
  display: block;
  width: 10px;
}

.sizeInput {
  white-space: nowrap;
}

.cuttingTool-lengthSizeError,
.cuttingTool-widthSizeError {
  padding-top: 2px;
  max-width: max-content;
  white-space: normal;
}

@media screen and (min-width: 960px) {
  .cuttingTool-lengthField,
  .cuttingTool-widthField {
    padding: 4px 6px;
  }
}
.cuttingTool-lengthField,
.cuttingTool-widthField {
  border: 1px solid #bbb;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 1rem;
  height: 2rem;
  line-height: 2rem;
  padding: 3px 5px;
  width: 80px;
  margin-right: 3.5px;
}

.cuttingTool-invalidField {
  border: 1px solid #e60000;
}

th.cuttingTool-quantity {
  width: 1px;
}

th.cuttingTool-price {
  width: 72px;
}

.groupName {
  margin: 6px 0 0;
}

td.inputColumn {
  vertical-align: top;
}

td.price {
  padding: 9px;
}

th > p {
  margin: 0 15px 0 0;
}

.customCutting-grid {
  display: none;
}

.noAvailability-note {
  text-align: center;
  width: 50%;
}

.crossSell-add {
  display: none;
}

.cuttingTool-table-container {
  left: 50%;
  margin-left: var(--full-width-element-margin);
  margin-right: var(--full-width-element-margin);
  overflow: hidden;
  position: relative;
  width: var(--viewport-width);
}
@media screen and (min-width: 1440px) {
  .cuttingTool-table-container {
    left: -10px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 0;
    width: 1440px;
  }
}
.cuttingTool-table-container .inputColumn {
  padding: 15px 8px;
}
.cuttingTool-table-container .price {
  padding-top: 21px;
}

.cuttingTool-sizeInput .mobile-break {
  flex-basis: 100%;
  height: 0;
}

@media screen and (min-width: 960px) {
  .cuttingTool-dropDown,
  .cuttingTool-unitField {
    margin-right: 15px !important;
  }
  .cuttingTool-lengthSizeError,
  .cuttingTool-widthSizeError {
    position: unset;
    max-width: 130px;
  }
}
.crossSellModal-productListing .crossSell-add {
  background-color: #ffef00;
  border: 1px solid black;
  border-radius: 8px;
  display: block;
  height: 30px;
  justify-self: end;
  margin: 0 0 5px 0;
  width: 50px;
}
.crossSellModal-productListing .crossSell-add:disabled {
  background-color: #ededed;
}
.crossSellModal-productListing .crossSell-add-imageContainer {
  vertical-align: bottom;
}
.crossSellModal-productListing .crossSell-addToSummary {
  font-weight: bold;
  text-align: center;
}
.crossSellModal-productListing .crossSellSummary-remove {
  background: #ededed;
  border-radius: 50%;
  border: none;
  height: 30px;
  width: 30px;
  vertical-align: bottom;
}
.crossSellModal-productListing .cutToSize-crossSellSummary-note {
  font-size: 13px;
}
.crossSellModal-productListing .cutToSize-crossSellSummary-repeatNote {
  background-color: #fff792;
  border: #fff792 2px solid;
  border-radius: 0px 0px 8px 8px;
  font-size: 11px;
  padding: 8px;
  text-align: center;
}
.crossSellModal-productListing .cuttingTool-table-container {
  left: 0;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}
.crossSellModal-productListing .customCutting-grid {
  gap: 1px;
  margin-bottom: 0;
  padding: 5px;
}
.crossSellModal-productListing #cut-to-size-submit-btn {
  display: none;
}
.crossSellModal-productListing .cuttingTool-sizeInput .sizeInput-wrapper input,
.crossSellModal-productListing .customCutting-sizeInput .sizeInput-wrapper input {
  width: 80%;
}
.crossSellModal-productListing .cuttingTool-table-container .customCutting-grid input[type=number],
.crossSellModal-productListing .cuttingTool-table-container .customCutting-grid select,
.crossSellModal-productListing .customCutting-table-container .customCutting-grid input[type=number],
.crossSellModal-productListing .customCutting-table-container .customCutting-grid select {
  height: 70%;
}
.crossSellModal-productListing .cutToSize-innerSummary {
  align-items: center;
  border-bottom: #bbb 1px solid;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  justify-content: space-between;
  margin: 10px 10px 0px 10px;
  padding: 0 10px;
}
.crossSellModal-productListing .cutToSize-innerSummary {
  animation: fadeIn 0.4s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.crossSellModal-productListing .crossSellSummary-remove:disabled img {
  color: #ededed;
}
.crossSellModal-productListing .cutToSize-CrossSell-details {
  margin: 10px 0 10px;
}
.crossSellModal-productListing .cutToSize-CrossSell-details br {
  display: none;
}
.crossSellModal-productListing .cutToSize-CrossSell-details:nth-child(3) {
  text-align: center;
}
@media screen and (min-width: 450px) {
  .crossSellModal-productListing .cutToSize-CrossSell-details:nth-child(3) {
    text-align: start;
  }
}
.crossSellModal-productListing .cutToSize-CrossSell-subHeading {
  font-size: 13px;
  font-weight: bold;
  margin: 0;
  margin-right: 10px;
  padding: 5px 0;
}

@media screen and (min-width: 960px) {
  .crossSellModal-productListing .cuttingTool-table-container {
    left: 0;
    margin-left: 0;
    margin-right: 0;
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  .crossSellModal-productListing .cuttingTool-table-container .inputColumn {
    align-content: center;
    vertical-align: middle;
  }
  .crossSellModal-productListing .cuttingTool-table-container .productTable-sidePadding {
    align-content: center;
  }
  .crossSellModal-productListing .cuttingTool-table-container td {
    padding: 0;
  }
  .crossSellModal-productListing .cuttingTool-table-container thead {
    display: none;
  }
  .crossSellModal-productListing .cuttingTool-table-container tr:hover {
    background: none;
  }
  .crossSellModal-productListing .cuttingTool-table-container tr:last-child td {
    border-bottom: none;
  }
  .crossSellModal-productListing .cuttingTool-table-container .cuttingTool-lengthSizeError {
    left: 45%;
    max-width: max-content;
    position: absolute;
  }
  .crossSellModal-productListing .button {
    display: none;
  }
  .crossSellModal-productListing .crossSell-add:disabled {
    background-color: #ededed;
  }
  .crossSellModal-productListing .crossSellSummary-removalContainer {
    margin-top: 10px;
  }
  .crossSellModal-productListing .crossSellSummary-remove {
    background: #ededed;
    border-radius: 50%;
    border: none;
    height: 40px;
    left: 0%;
    top: 0%;
    width: 40px;
  }
  .crossSellModal-productListing .groupName {
    margin-left: 13px;
  }
  .crossSellModal-productListing .groupName, .crossSellModal-productListing .cuttingTool-dropDown,
  .crossSellModal-productListing .inputColumn, .crossSellModal-productListing .sizeInput-wrapper, .crossSellModal-productListing .cuttingTool-unitField {
    font-size: 13px;
  }
  .crossSellModal-productListing .cutToSize-CrossSell-highlight {
    font-size: 13px;
    font-weight: bold;
    margin: 0;
  }
  .crossSellModal-productListing .cutToSize-innerSummary {
    border-bottom: #bbb 1px solid;
    display: flex;
    flex-direction: row;
    font-size: 12px;
    justify-content: space-between;
    margin: 1rem 1rem 0rem 1rem;
    padding-bottom: 0.5px;
  }
  .crossSellModal-productListing .cuttingTool-quantityContainer {
    display: flex;
    margin: 20px 0 7px;
    min-height: 2rem;
    width: 115px;
    justify-self: center;
  }
}
@media screen and (min-width: 960px) and (min-width: 1440px) {
  .crossSellModal-productListing .cuttingTool-quantityContainer {
    margin: 25px 0 7px;
  }
}
@media screen and (min-width: 960px) {
  .crossSellModal-productListing .customCutting-field {
    border: 1px solid #c9c9c9;
    font-size: 0.9125rem;
    max-width: 40%;
    text-align: center;
  }
  .crossSellModal-productListing .quantityInputColumn {
    justify-items: center;
    text-align: center;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */